import * as React from "react"
import { Checker } from "../components/Icons/Icons"
import Layout from '../components/Layout/Layout'
import * as styles from '../styles/Index.module.css'

// markup
const IndexPage = () => {
  return (
    <main>
      <title>Home Page</title>
      <Layout>
        <div className={styles.mainContainer}>
          <section className={styles.section}>
            <h2 className={styles.heading}>Benefits of cryptocurrency processing with <strong>CryptoMerchantProcessor.com:</strong></h2>
            <ul className={styles.list}>
              <li><Checker /> INCLUDED -Training material to train employees how to use the software</li>
              <li><Checker />NO set up fees – Go live in under 72 hours</li>
              <li><Checker />Reduce processing fees</li>
              <li><Checker />Eliminate credit card chargebacks</li>
              <li><Checker />Eliminate customer card denials - No transaction volume limits</li>
              <li><Checker />No limit on transaction amounts</li>
              <li><Checker />Free software download - compatible with any android or iOS enabled device</li>
            </ul>
          </section>
          <section className={styles.section}>
            <p><strong>cryptomerchantprocessor.com</strong> cryptocurrency processing has you protected against any changes in market value with our price protection guarantee.  You keep the exact value a customer pays you, minus a 1.99% transaction fee.  You have the choice if payments are received in cryptocurrency or cash.</p>
            <p>If kept as crypto, it is a non-taxable event and you can accumulate an appreciating asset.</p>
            <p>Consider the potential of cryptocurrency, where if you sold a worth $10 today, and it was worth $20 tomorrow.</p>
          </section>
          <section className={styles.section}>
            <p>Accept payments online, send invoices, or via an in-store payment terminal.  This system works with brick and mortar businesses as well as e-commerce platforms.  Payments are accepted with a simple QR code and can be integrated with your inventory system.</p>
            <ul className={styles.list}>
              <li><Checker />All crypto sales are fully documented and accounted for Cash settlements are deposited via ACH daily</li>
              <li><Checker />Since you are selling cryptocurrency in your business, give the customers the ability to spend it also!</li>
              <li><Checker />This also complements our Bitcoin ATMs perfectly!  </li>
            </ul>
            <h2 className={styles.cta}>To get started, fill out the application below and we will contact you to finalize the process and get you started!</h2>
            <a className={styles.button} href="https://form.jotform.com/213066599253159" target="_blank" rel="noreferrer">Application</a>
          </section>
        </div>
      </Layout>
    </main>
  )
}

export default IndexPage
